// Common/TransactionDetailModal.jsx
import React, { useRef } from "react";
import { TiPrinter } from "react-icons/ti";
import { useReactToPrint } from "react-to-print";
import moment from "moment";
import { useSelector } from "react-redux";
import { ThreeDots } from "react-loader-spinner";
import ActionButton from "../component/Common/ActionButton";
import CommonDetailModal from "../component/Common/CommonDetailModal";

const TransactionDetailModal = ({
  // Required props
  transactions = [],
  onClose,
  PrintName,
  isExpense,
  isInvoice,
  // Optional props with defaults
  title = "Transaction Details",

  // Data configuration
  columns = [
    {
      key: "date",
      label: "Txn Date",
      accessor: (transaction) => moment(transaction?.EntryDate?.slice(0, 10))?.format("DD-MMM-YY"),
    },
    {
      key: "account",
      label: "Account",
      accessor: (transaction) => transaction?.Account?.AccountTitle,
    },
    {
      key: "narration",
      label: "Narration",
      accessor: (transaction) => transaction?.Narration,
    },
  ],

  // Totals (if not provided, will calculate)
  debitTotal = null,
  creditTotal = null,

  // Print functionality
  PrintComponent = null,
  printProps = {},
  isLoading = false,

  // Styling
  modalClassName = "modal-content-cat_voucher",
  tableClassName = "table_height-voucher",
}) => {
  const componentRefModal = useRef();
  const rolesdata = useSelector((state) => state.GetAllRole);

  const printGenrealRecModal = useReactToPrint({
    content: () => componentRefModal.current,
  });

  // Calculate totals if not provided
  const calculateTotals = () => {
    if (debitTotal !== null && creditTotal !== null) {
      return { debitTotal, creditTotal };
    }

    let debit = 0;
    let credit = 0;

    transactions.forEach((transaction) => {
      const amount = parseFloat(transaction?.Amount || 0);
      const type = transaction?.TransactionType;

      if (type === "DEBIT") {
        debit += amount;
      } else if (type === "CREDIT") {
        credit += amount;
      }
    });

    return { debitTotal: debit, creditTotal: credit };
  };

  const { debitTotal: finalDebit, creditTotal: finalCredit } = calculateTotals();

  // Handle click on overlay to close modal
  // const handleOverlayClick = (e) => {
  //     if (e.target === e.currentTarget) {
  //         onClose();
  //     }
  // };

  // Check if print is allowed
  const canPrint = rolesdata?.data?.UserRoles?.includes("Settings_Export") && PrintComponent;

  const bottomContent = (
    <div className="row mx-0">
      <div className="col-12">
        <div className={`table-responsive ${tableClassName}`}>
          <table className="table table-borderless m-0">
            <thead>
              <tr>
                <th>Sr</th>
                {columns.map((column, index) => (
                  <th style={{ minWidth: "100px" }} key={`col-${index}`}>
                    {column.label}
                  </th>
                ))}
                <th>Debit</th>
                <th>Credit</th>
              </tr>
            </thead>

            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={columns.length + 3} className="text-center p-4">
                    <div className="d-flex justify-content-center align-items-center">
                      <ThreeDots color="green" height={40} width={40} />
                    </div>
                  </td>
                </tr>
              ) : transactions.length > 0 ? (
                <>
                  {transactions.map((transaction, index) => (
                    <tr key={`row-${index}`}>
                      <td className="table_data">{index + 1}</td>
                      {columns.map((column, colIndex) => (
                        <td className="table_data" key={`cell-${index}-${colIndex}`}>
                          {column.accessor(transaction)}
                        </td>
                      ))}
                      <td className="table_data">
                        {transaction?.TransactionType === "DEBIT"
                          ? parseFloat(transaction?.Amount || 0)?.toLocaleString()
                          : null}
                      </td>
                      <td className="table_data">
                        {transaction?.TransactionType === "CREDIT"
                          ? parseFloat(transaction?.Amount || 0)?.toLocaleString()
                          : null}
                      </td>
                    </tr>
                  ))}

                  {/* Totals row */}
                  <tr>
                    <td className="table_data" colSpan={columns.length + 1}>
                      <label className="input_label m-0 float-right">Total:</label>
                    </td>
                    <td className="table_data">
                      <input
                        type="text"
                        className="input_styling transaction-total-input"
                        placeholder="Debit"
                        disabled
                        value={parseFloat(finalDebit).toLocaleString()}
                        readOnly
                      />
                    </td>
                    <td className="table_data">
                      <input
                        type="text"
                        className="input_styling transaction-total-input"
                        placeholder="Credit"
                        disabled
                        value={parseFloat(finalCredit).toLocaleString()}
                        readOnly
                      />
                    </td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan={columns.length + 3} className="text-center py-4">
                    No transactions found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Print button */}
      {canPrint && (
        <div className="col-12 mt-2">
          <span className="float-left mt-1">
            <ActionButton
              text="Print"
              icon={TiPrinter}
              isPrint={true}
              newBtn="true"
              onClick={printGenrealRecModal}
            />
          </span>
        </div>
      )}
    </div>
  );

  return (
    <>
      {/* Hidden print component */}
      {canPrint && PrintComponent && (
        <div hidden>
          <PrintComponent
            ref={componentRefModal}
            PrintName={PrintName}
            debittotal={finalDebit}
            credittotal={finalCredit}
            debitTotal={finalDebit}
            creditTotal={finalCredit}
            total={finalDebit}
            printData={transactions}
            voucherNumber={
              isExpense ? "Expense Voucher" : isInvoice ? "Invoice Receipt" : "General Receipt"
            }
            {...printProps}
          />
        </div>
      )}

      <CommonDetailModal
        isOpen={true}
        onClose={onClose}
        title={title}
        maxWidth="1000px"
        details={[]}
        bottomContent={bottomContent}
      />
    </>
  );
};

export default TransactionDetailModal;

// // Common/TransactionDetailModal.jsx
// import React, { useRef } from "react";
// import { TiPrinter } from "react-icons/ti";
// import { useReactToPrint } from "react-to-print";
// import moment from "moment";
// import { useSelector } from "react-redux";
// import ActionButton from "../component/Common/ActionButton";

// const TransactionDetailModal = ({
//   // Required props
//   transactions = [],
//   onClose,
//   PrintName,
//   isExpense,
//   isInvoice,
//   // Optional props with defaults
//   title = "Transaction Details",

//   // Data configuration
//   columns = [
//     {
//       key: "date",
//       label: "Txn Date",
//       accessor: (transaction) =>
//         moment(transaction?.EntryDate?.slice(0, 10))?.format("DD-MMM-YY"),
//     },
//     {
//       key: "account",
//       label: "Account",
//       accessor: (transaction) => transaction?.Account?.AccountTitle,
//     },
//     {
//       key: "narration",
//       label: "Narration",
//       accessor: (transaction) => transaction?.Narration,
//     },
//   ],

//   // Totals (if not provided, will calculate)
//   debitTotal = null,
//   creditTotal = null,

//   // Print functionality
//   PrintComponent = null,
//   printProps = {},

//   // Styling
//   modalClassName = "modal-content-cat_voucher",
//   tableClassName = "table_height-voucher",
// }) => {
//   const componentRefModal = useRef();
//   const rolesdata = useSelector((state) => state.GetAllRole);

//   const printGenrealRecModal = useReactToPrint({
//     content: () => componentRefModal.current,
//   });

//   // Calculate totals if not provided
//   const calculateTotals = () => {
//     if (debitTotal !== null && creditTotal !== null) {
//       return { debitTotal, creditTotal };
//     }

//     let debit = 0;
//     let credit = 0;

//     transactions.forEach((transaction) => {
//       const amount = parseFloat(transaction?.Amount || 0);
//       const type = transaction?.TransactionType;

//       if (type === "DEBIT") {
//         debit += amount;
//       } else if (type === "CREDIT") {
//         credit += amount;
//       }
//     });

//     return { debitTotal: debit, creditTotal: credit };
//   };

//   const { debitTotal: finalDebit, creditTotal: finalCredit } =
//     calculateTotals();

//   // Handle click on overlay to close modal
//   // const handleOverlayClick = (e) => {
//   //     if (e.target === e.currentTarget) {
//   //         onClose();
//   //     }
//   // };

//   // Check if print is allowed
//   const canPrint =
//     rolesdata?.data?.UserRoles?.includes("Settings_Export") && PrintComponent;

//   return (
//     <>
//       {/* Hidden print component */}
//       {canPrint && PrintComponent && (
//         <div hidden>
//           <PrintComponent
//             ref={componentRefModal}
//             PrintName={PrintName}
//             debittotal={finalDebit}
//             credittotal={finalCredit}
//             total={finalDebit}
//             printData={transactions}
//             voucherNumber={isExpense ? "Expense Voucher": isInvoice ?"Invoice Receipt" : "General Receipt"}
//             {...printProps}
//           />
//         </div>
//       )}

//       {/* Modal overlay */}
//       <div className="modal-overlay">
//         <div className={modalClassName} onClick={(e) => e.stopPropagation()}>
//           <div className="row">
//             <div className="col-12 page_heading">
//               <h5 className="mb-0">{title}</h5>
//               <span className="close pr-2" onClick={onClose}>
//                 &times;
//               </span>
//             </div>
//           </div>

//           <div className="row">
//             <div className="col-12">
//               <div className={`table-responsive_modal ${tableClassName}`}>
//                 <table className="table table-borderless m-0">
//                   <thead>
//                     <tr>
//                       <th>Sr</th>
//                       {columns.map((column, index) => (
//                         <th style={{ minWidth: "100px" }} key={`col-${index}`}>
//                           {column.label}
//                         </th>
//                       ))}
//                       <th>Debit</th>
//                       <th>Credit</th>
//                     </tr>
//                   </thead>

//                   <tbody>
//                     {transactions.length > 0 ? (
//                       <>
//                         {transactions.map((transaction, index) => (
//                           <tr key={`row-${index}`}>
//                             <td className="table_data">{index + 1}</td>
//                             {columns.map((column, colIndex) => (
//                               <td
//                                 className="table_data"
//                                 key={`cell-${index}-${colIndex}`}
//                               >
//                                 {column.accessor(transaction)}
//                               </td>
//                             ))}
//                             <td className="table_data">
//                               {transaction?.TransactionType === "DEBIT"
//                                 ? parseFloat(
//                                   transaction?.Amount || 0,
//                                 )?.toLocaleString()
//                                 : null}
//                             </td>
//                             <td className="table_data">
//                               {transaction?.TransactionType === "CREDIT"
//                                 ? parseFloat(
//                                   transaction?.Amount || 0,
//                                 )?.toLocaleString()
//                                 : null}
//                             </td>
//                           </tr>
//                         ))}

//                         {/* Totals row */}
//                         <tr>
//                           <td
//                             className="table_data"
//                             colSpan={columns.length + 1}
//                           >
//                             <label className="input_label m-0 float-right">
//                               Total:
//                             </label>
//                           </td>
//                           <td className="table_data">
//                             <input
//                               type="text"
//                               className="input_styling"
//                               placeholder="Debit"
//                               disabled
//                               value={parseFloat(finalDebit).toLocaleString()}
//                               readOnly
//                             />
//                           </td>
//                           <td className="table_data">
//                             <input
//                               type="text"
//                               className="input_styling"
//                               placeholder="Credit"
//                               disabled
//                               value={parseFloat(finalCredit).toLocaleString()}
//                               readOnly
//                             />
//                           </td>
//                         </tr>
//                       </>
//                     ) : (
//                       <tr>
//                         <td
//                           colSpan={columns.length + 3}
//                           className="text-center py-4"
//                         >
//                           No transactions found
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>
//             </div>

//             {/* Print button */}
//             <div className="col-12 mt-2">
//               {canPrint && (
//                 <span className="float-left mt-1">
//                   <ActionButton
//                     text="Print"
//                     icon={TiPrinter}
//                     isPrint={true}
//                     newBtn="true"
//                     onClick={printGenrealRecModal}
//                   />
//                 </span>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default TransactionDetailModal;
